import styled from '@emotion/styled';

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Row = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const FieldGroup = styled.div`
    width: 100%;

    .MuiFormControl-root {
        width: 100%;
    }

    .MuiInputLabel-root {
        color: #64748b;
        font-size: 14px;
        font-weight: 500;
    }

    .MuiInputLabel-root.Mui-focused {
        color: #6d41d8;
    }

    .MuiOutlinedInput-root {
        border-radius: 16px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
        transition:
            box-shadow 0.2s ease,
            border-color 0.2s ease,
            transform 0.2s ease;
    }

    .MuiOutlinedInput-root:hover {
        transform: translateY(-1px);
        box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    }

    .MuiOutlinedInput-notchedOutline {
        border-color: rgba(148, 163, 184, 0.28);
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
        border-color: rgba(131, 83, 226, 0.32);
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: #8353e2;
    }

    .MuiFormHelperText-root {
        margin-left: 4px;
        font-size: 12px;
    }
`;

export const OptionGrid = styled.div`
    display: grid;
    gap: 12px;
`;

export const OptionCard = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 16px;
    border: 1px solid rgba(148, 163, 184, 0.18);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.72);
    cursor: pointer;
    backdrop-filter: blur(12px);
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease,
        transform 0.2s ease;

    &:hover {
        transform: translateY(-1px);
        border-color: rgba(131, 83, 226, 0.28);
        box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    }

    .MuiCheckbox-root {
        margin: -6px 0 0 -6px;
        color: #8353e2;
    }
`;

export const OptionContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const OptionTitle = styled.span`
    color: #111827;
    font-size: 14px;
    font-weight: 600;
`;

export const OptionDescription = styled.span`
    color: #64748b;
    font-size: 12px;
    line-height: 1.5;
`;
